import { z } from "zod";
import { farmAdviceDrillDownDtoSchema } from "./farm-advice-drill-down.schema";
import { farmAdviceSolutionDtoSchema } from "./farm-advice-solution.schema";
import { richTextBlockDtoSchema } from "./rich-text-block.schema";
export const farmAdviceCategoryDtoSchema = z.union([
    z.literal("visitBehavior"),
    z.literal("preTreatment"),
    z.literal("attachment"),
    z.literal("startMilking"),
    z.literal("peakMilking"),
    z.literal("endMilking"),
    z.literal("postTreatment"),
    z.literal("general"),
    z.literal("health"),
]);
export const farmAdviceScopeDtoSchema = z.union([
    z.literal("cow"),
    z.literal("groupOrHerd"),
    z.literal("astronaut"),
    z.literal("farm"),
]);
export const farmAdvicePriorityDtoSchema = z.union([
    z.literal("high"),
    z.literal("medium"),
    z.literal("low"),
    z.literal("hint"),
]);
export const farmAdviceDtoSchema = z.object({
    adviceId: z.string(),
    farmLicenseKey: z.string(),
    inValidation: z.boolean(),
    title: z.string(),
    category: farmAdviceCategoryDtoSchema,
    scope: farmAdviceScopeDtoSchema,
    priority: farmAdvicePriorityDtoSchema,
    context: z.array(richTextBlockDtoSchema),
    problem: z.array(richTextBlockDtoSchema),
    solutions: z.array(farmAdviceSolutionDtoSchema),
    drillDown: farmAdviceDrillDownDtoSchema.nullable(),
    generatedAtUtc: z.string().datetime(),
    timeframeSeconds: z.number().nullable(),
});
//# sourceMappingURL=farm-advice.schema.js.map